module.exports = __webpack_public_path__ + "static/img/logo12.949094a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo12.png
// module id = dRHj
// module chunks = 1